import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";

export const getStaffEmployeePersonalColumns = (
  t: TFunction,
  options: string[]
): ColumnsType<any> =>
  options.map((option) => ({
    title: t(`cep.${option}`),
    dataIndex: option,
    key: option,
    render: (value: any) => <span>{value}</span>,
  }));
